import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/root-reducer';
import { ErrorInfo, RenderingState } from 'redux/types';

export const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const updateApplicationFormSlice = createSlice({
  name: 'UPDATE_APPLICATION_FORM',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error.message = '';
      state.error.statusCode = null;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error.message = action.payload.message;
      state.error.statusCode = action.payload.statusCode;
    },
  },
});

// REDECER
export default updateApplicationFormSlice.reducer;

// ACTIONS
export const { loading, success, failure } = updateApplicationFormSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.job.create.applicationForm.update.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.job.create.applicationForm.update.success;
export const selectError = (state: RootState) =>
  state.ui.job.create.applicationForm.update.error;
